import React, {useState} from 'react';
import { connect } from "react-redux";

import {isPc, redirectToLogin} from '../../utils/util';
import globalAction from '../../actions/global';
import {logout} from '../../pages/api';

function Header ({userData, showLoginModal, toggleRegModal}) {
    const [showLogoutBtn, setShowLogoutBtn] = useState(false);
    const handleClickLogin = () => {
        if (isPc()) {
            showLoginModal();
        } else {
            redirectToLogin();
        }
    }
    const handleUserInfoClick = () => {
        if (!isPc()) {
            setShowLogoutBtn(!showLogoutBtn);
        }
    }

    async function __logout() {
        // let url = encodeURI(window.location.href);
        // window.location.href = `https://reg.163.com/Logout.jsp?username=${userData.uid}&url=${url}`;
        const {result} = await new logout().fetch();
        
        if (result.code === 200) {
            window.location.reload();
        }
    }
    
    return (
        <div className="g-header">
            <div className="m-header-left">
                <a className="m-header-logo" href="https://vipmail.163.com/" target="_blank">网易VIP邮箱</a>
            </div>
            {
                (userData && userData.uid) ?
                    <div className="m-header-right">
                        <div className={["u-user-content", showLogoutBtn ? 'active' : ''].join(' ')}>
                            <span onClick={handleUserInfoClick}>欢迎您 <span>{userData.uid}</span></span>
                            {
                                <div className="dropdown">
                                    <ul>
                                        <li onClick={ __logout }>退出</li>
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    :
                    <div className="m-header-right">
                        <a href="javascript:void(0)" onClick={handleClickLogin}>登 录</a>
                        <a href="javascript:void(0)" onClick={() => {toggleRegModal(true)}}>注册VIP邮箱</a>
                    </div>
            }
        </div>
    )
}


function mapStateToProps(state) {
    return {
        userData: state.global.userData
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showLoginModal() {
            dispatch(globalAction.toggleLoginModal(true));
        },
        toggleRegModal(flag) {
            dispatch(globalAction.toggleRegModal(flag));
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Header);